// "Anticipated cost" of a case's Care Forecast (careForecast on the Initial
// Assessment Summary, shown for organizations with the
// careDocuments.careForecast setting on — PPL-3295). Values are stable slug
// keys stored in documents; forms and PDFs render the display helpers.
export enum AnticipatedCareCost {
  withinDelegatedAuthority = 'within-delegated-authority',
  beyondDelegatedAuthority = 'beyond-delegated-authority',
}

export function displayAnticipatedCareCost(value: AnticipatedCareCost) {
  switch (value) {
    case AnticipatedCareCost.withinDelegatedAuthority:
      return 'Within delegated authority';
    case AnticipatedCareCost.beyondDelegatedAuthority:
      return 'Beyond delegated authority';
    default:
      throw new Error(`Unknown anticipated care cost: ${value}`);
  }
}

// Form option label: spells out the pre-authorisation consequence to the
// clinician choosing; documents render the plain displayAnticipatedCareCost.
export function displayAnticipatedCareCostOption(value: AnticipatedCareCost) {
  switch (value) {
    case AnticipatedCareCost.beyondDelegatedAuthority:
      return 'Beyond delegated authority - a pre-authorisation request will be shared';
    default:
      return displayAnticipatedCareCost(value);
  }
}
